import React from 'react';
import MeHeaderV2 from './components/me-header';
import {RefreshProvider} from './components/me-header/hooks';
import {useMe} from './hooks';
import MeList from './components/me-list';
import Spin from '@/components/basic/spin';

const Me = () => {
  const {meHeaderRef, refresh, loading} = useMe();
  return (
    <div className="size-full overflow-hidden">
      <Spin
        style={{height: '100%', width: '100%', overflow: 'hidden'}}
        overlayStyle={{zIndex: 100}}
        loading={loading}>
        <div
          className="me-wrap overflow-auto bg-bg"
          style={{height: 'calc(100vh - 3.5rem)'}}
          id="me-container">
          <RefreshProvider.Provider value={{refresh}}>
            <MeHeaderV2 ref={meHeaderRef} />
            <MeList />
          </RefreshProvider.Provider>
        </div>
      </Spin>
    </div>
  );
};

export default Me;
